import postal from 'postal';
import React from 'react';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import Lightbox from '../../../../components/shared/Lightbox';
import { urlReformatPhotos } from '../../../../utils/lightbox_helpers';

const createReactClass = require('create-react-class');

const PhotosTab = createReactClass({
  getInitialState() {
    return {
      lightboxOpen: false,
      lightboxStartingIndex: null,
      lightboxImages: []
    };
  },
  addMapPhotoMarkers(photos) {
    this.props.messagingChannel.publish({
      topic: 'mapPhoto.add.toModel',
      data: photos
    });
  },
  handlePhotoHover(mapPhotoId) {
    this.props.messagingChannel.publish({
      topic: 'photo.hover',
      data: mapPhotoId
    });
  },
  handlePlaceholderClick() {
    if (this.props.currentUser && this.props.currentUser.id == this.props.track.user.id) {
      const url = `/api/alltrails/maps/${this.props.track.id}/photos?key=${ServerCommunicationUtil.apiKey}`;
      this.props.openTrailFormModal('photos', { url, onPhotosAdd: this.handlePhotosUpload });
    }
  },
  handlePhotosUpload(data) {
    const photos = data.detail;
    if (this.props.handlePhotosUpload) this.props.handlePhotosUpload(photos);
    this.addMapPhotoMarkers(photos);
  },
  handleMapPhotoAdded(data) {
    const photos = [data.photo];
    if (this.props.handlePhotosUpload) this.props.handlePhotosUpload(photos);
    this.addMapPhotoMarkers(photos);
  },
  handleMapPhotoClick(mapPhotoId) {
    let lightboxStartingIndex;
    const lightboxImages = this.props.data.map((item, index) => {
      if (mapPhotoId === item.photo.id) {
        lightboxStartingIndex = index;
      }

      return { ...item.photo, map_id: item.mapId };
    });

    this.setState({ lightboxImages, lightboxStartingIndex, lightboxOpen: true });
  },
  handleLightboxClose() {
    this.setState({ lightboxOpen: false, lightboxStartingIndex: null, lightboxImages: [] });
  },
  getLightboxProps() {
    return {
      isOpen: this.state.lightboxOpen,
      images: urlReformatPhotos(this.state.lightboxImages),
      handleCloseRequest: this.handleLightboxClose,
      startingIndex: this.state.lightboxStartingIndex,
      mapId: this.props.track.id
    };
  },
  renderLightbox() {
    if (!this.state.lightboxOpen) {
      return;
    }

    return <Lightbox {...this.getLightboxProps()} />;
  },
  render() {
    const sortedPhotos = this.props.data.sort(function(a, b) {
      return new Date(a.photo.metadata.created) - new Date(b.photo.metadata.created);
    });

    let photos = [];
    if (sortedPhotos && sortedPhotos.length > 0) {
      photos = sortedPhotos.map(
        function(mapPhoto) {
          const { id } = mapPhoto.photo;
          const hash = mapPhoto.photo.photoHash;
          const fallbackPhotoUrl = `/api/alltrails/photos/${id}/image?size=medium_square&key=${ServerCommunicationUtil.apiKey}`;
          let photoUrl;
          if (id && hash) {
            photoUrl = `https://cdn-assets.alltrails.com/uploads/photo/image/${id}/medium_square_${hash}.jpg`;
          } else {
            photoUrl = fallbackPhotoUrl;
          }
          let shouldFallback = true;
          const addFallbackSrc = ev => {
            if (shouldFallback) {
              ev.target.src = fallbackPhotoUrl;
              ev.target.onerror = null;
            }
            shouldFallback = false;
          };
          const clickHandler = () => this.handleMapPhotoClick(id);
          let hoverHandler = null;
          if (mapPhoto.location && mapPhoto.location.latitude != null && mapPhoto.location.longitude != null) {
            hoverHandler = this.handlePhotoHover.bind(null, mapPhoto.id, id);
          }
          return (
            <li key={`photo-${mapPhoto.id}`} onClick={clickHandler} onMouseOver={hoverHandler}>
              <img height="110" width="110" src={photoUrl} onError={addFallbackSrc} />
            </li>
          );
        }.bind(this)
      );
    }

    if (this.props.currentUser && this.props.currentUser.id == this.props.track.user.id) {
      const addPhotosSquare = (
        <li key="photo-add" onClick={this.handlePlaceholderClick}>
          <div className="add-photos-square link">
            <p>
              {StringConstantsMixin.strings.ADD}
              <br />
              {StringConstantsMixin.strings.TAB_NAMES.PHOTOS}
            </p>
          </div>
        </li>
      );
      photos.unshift(addPhotosSquare);
    }

    if (!photos.length) {
      return null;
    }
    if (photos.length < 3) {
      const numToAdd = 3 - photos.length;
      for (let i = 0; i < numToAdd; i++) {
        photos.push(
          <li key={`placeholder-${i}`} onClick={this.handlePlaceholderClick}>
            <img width="110" height="110" src="//cdn-assets.alltrails.com/assets/placeholder/trail_placeholder.png" />
          </li>
        );
      }
    }

    return (
      <>
        <div id="photos-tab" className="inner-scroll-tab">
          <div className="action-bar">
            <menu className="title clearfix overview-menu tabs">
              <li className="active">
                <h3>
                  <a name={StringConstantsMixin.strings.TAB_NAMES.PHOTOS}>{StringConstantsMixin.strings.TAB_NAMES.PHOTOS}</a>
                </h3>
              </li>
            </menu>
          </div>
          <div className="inner-tab">
            <ul>{photos}</ul>
          </div>
        </div>
        {this.renderLightbox()}
      </>
    );
  }
});

export { PhotosTab };
